// Opens a static PDF reliably even when the server returns a wrong Content-Type
// (some static hosts serve .pdf as text/html, which makes the browser show raw bytes).
// We fetch the bytes and re-wrap them in a Blob with an explicit application/pdf type.

export async function openPdf(e, url) {
  if (e) e.preventDefault();
  // Open the tab synchronously so the user-gesture isn't lost to the popup blocker.
  const win = window.open("", "_blank");
  try {
    const res = await fetch(url, { cache: "no-store" });
    if (!res.ok) throw new Error("fetch failed");
    const buf = await res.arrayBuffer();
    const blobUrl = URL.createObjectURL(new Blob([buf], { type: "application/pdf" }));
    if (win) win.location = blobUrl;
    else window.open(blobUrl, "_blank", "noopener,noreferrer");
    setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
  } catch {
    if (win) win.location = url;
    else window.open(url, "_blank", "noopener,noreferrer");
  }
}

export async function pdfBlobUrl(url) {
  const res = await fetch(url, { cache: "no-store" });
  const buf = await res.arrayBuffer();
  return URL.createObjectURL(new Blob([buf], { type: "application/pdf" }));
}
